/*============================================================================
  - SPOTIRE: current template
  - Include all javascript for the current template
==============================================================================*/
$(document).on('ready', function (){

    $('.load_more_product').click(function () {
        $('.tab-content').toggleClass("focus_produc");

        $('.nav-item').click(function(e){
            if(!$(e.target).is('.tab-content, .tab-content*')){
                if($('.tab-content').hasClass( "focus_produc" ) && $('.nav-item').hasClass( "active" ));
                {
                    $('.tab-content').removeClass('focus_produc');
                }
            }
        });
    });

    var array = $(".cover-content-tab .tab-home-page .all-products-rr .tab-content ul li .img_product_home");
    var height = 0;
    for(i = 0; i < array.length; i++){
        if($(array[i]).height() > height){
            height = $(array[i]).height();
        }
    }
    $(array).height(height);

    $('.nav-tabs').click(function() {
        $('.nav-tabs').toggleClass('icons_typo_home');
    });


    var href;
    var url = location.href.substring(0, location.href.indexOf('?'));
    if(url){
        href = url.match(/([^\/]*)\/*$/)[1];
    }else{
        href = location.href.match(/([^\/]*)\/*$/)[1];
    }
    $(".no-bullets li a").each(function() {
        var current_url = this.href.substring(this.href.lastIndexOf('/') + 1);
        if (current_url === href) {
            $(this).parent().addClass('active');
        }
    });

    $(".no-bullets").click(function () {
        $(this).toggleClass("focus");
    });
    $(".tab-pane .load_more_product").click(function () {
        $(".tab-content .tab-pane ul .item").toggleClass("active");
    });
});
